import React, {useState} from 'react';
import Moment from 'react-moment';
// import ReactHtmlParser from "react-html-parser";
// import { Icon } from 'helpers/icons';

const ResultListingBody = ({test}) => {

    return(
        <>
            <div className='border-l-steal-c-100 border-l-4'>
                {test?.TestResults?.length ?
                    <div className="flex items-center bg-slate-100 p-2 gap-x-4 justify-between">
                        <p className="w-1/5">
                            Observation  
                        </p>
                        <p className="w-1/5">
                            Result
                        </p>
                        <p className="w-1/5">
                            Flag
                        </p>
                        <p className="w-1/5">
                            Range
                        </p>
                        <p className="w-1/5">
                            Result Date
                        </p>
                    </div>
                    :
                    <div className="flex flex-row items-center bg-slate-100 px-2 py-2 gap-x-8">
                        <p className="w-full text-center">
                            No Results found.
                        </p>
                    </div>
                }
            </div>

            <div className={`divide-y divide-gray-200 bg-white alternative-color font-light`}>
                {test.TestResults?.map((result, index)=>{
                    return(
                        <div key={index}>
                            <div className={`border-b-2 flex items-center p-2 gap-x-4 justify-between`} style={{borderLeft: result.color_code != '#000000' ? `4px solid ${result.color_code}` : '4px solid #cdd7e1'}}>
                                <div className="w-1/5 flex items-center">
                                    <Icon type="observation" /> {result.code} {result.short_desc}
                                </div>
                                <div className="w-1/5" style={{color: result.color_code}}>
                                    {result.result ? result.result : '-'}
                                </div>
                                <div className="w-1/5" style={{color: result.color_code}}>
                                    {result.flag_text ? result.flag_text : '-'}
                                </div>
                                <div className='w-1/5'>
                                    {`${result.range_min} ${result.range_min && result.range_max ? '-' : ''} ${result.range_max}`}
                                </div>
                                <p className="w-1/5">
                                    <Moment format="MM/DD/YYYY">
                                        {test.result_datetime ? test.result_datetime : '-'}
                                    </Moment>
                                </p>
                            </div>
                            {/* (lab.allow_manual_results == false || lab.acknowledged == true) */}
                            {(result.result_notes) ?
                                <div className={`border-b-2 flex bg-slate-100 p-2 gap-x-4 border-left-teal-c-100-20`}>
                                    {/* <span className='flex gap-1 items-center align-middle'><Icon type="note" /> <b>Note:</b></span> {ReactHtmlParser(result.result_notes?.replaceAll('<br />', ' '))} */}
                                </div>
                                : null
                            }
                        </div>
                    )
                })}
            </div>
        </>
    )
}

export default ResultListingBody;